import Step1 from "./Step1";
import Step2 from "./Step2";
import Step3 from "./Step3";
import StepDeliveryPage from "./StepDeliveryPage";
import StepPrepayPage from "./StepPrepayPage";
import MultiLocation from "./MultiLocation";
import SingleDayType from "./SingleDayType";

const steps = [
    {
        id: 1,
        component: SingleDayType,
        name:'Single Day Type',
        validator: 'step_return',
        error: null,
        success: false,
        hidden:true,
        single_day_type: true
    },
    {
        id: 2,
        component: MultiLocation,
        name:'Multi Location',
        validator: 'step_return',
        hidden:true,
        error: null,
        multi_location_page: true
    },
    {
        id: 3,
        component: StepDeliveryPage,
        name:'Delivery',
        validator: 'step_delivery',
        error: null,
        success: false,
        hidden:true,
        delivery_page: true
    },
    {
        id: 4,
        component: StepPrepayPage,
        name:'Prepay',
        validator: 'step_prepay',
        error: null,
        success: false,
        hidden:true,
        prepay_page: true,
        prepay_pay: true
    },
    {
        id: 5,
        _id:1,
        component: Step1,
        name:'General information',
        validator: 'step_1',
        error: null,
        success: false
    },
    {
        id: 6,
        _id:2,
        component: Step2,
        name:'Renters details',
        validator: 'step_2',
        error: null,
        success: false
    },
    {
        id: 7,
        _id:3,
        component: Step3,
        name:'Overview and payment',
        error: null,
        success: false
    },
    {
        id: 8,
        component: Step3,
        validator: 'step_3',
        hidden:true,
        error: null,
        prepay_pay: true
    }
];

export default steps;
